import RemisesFinAnneeController from './remises.fin.annee.controller';

export default {
    template: require('./remises.fin.annee.tpl.html'),
    controller: RemisesFinAnneeController
};
